//仓库数据
import request from '@/utils/request'

// 查询
export function fetchList (data) {
  return request.post('/basics/warehouse/page', data)
}

// 新建
export function create (data) {
  return request.post('/basics/warehouse/create', data, {
    trim: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/basics/warehouse/create', data, {
    trim: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/basics/warehouse/delete/${id}`)
}

// // 批量删除
// export function deleteByIdInBatch (ids) {
//   return request.get('/system/permission/delete/batch', {
//     params: {
//       ids
//     }
//   })
// }
